/**
 * Whisk Gutenberg.
 *
 * @package whisk-recipes
 */

wp.domReady(
	function () {
		const dispatch = wp.data.dispatch;

		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_tag' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_ingredient' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_equipment' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_diet' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_avoidance' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_cuisine' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_meal_type' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_cooking_technique' );
		dispatch( 'core/edit-post' ).removeEditorPanel( 'taxonomy-panel-whisk_nutrition' );
	}
);
